export default "__VITE_ASSET__CrFX9Ov$__"